"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactMapGl = _interopRequireDefault(require("react-map-gl"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hooks = require("../hooks");

var _shallow = _interopRequireDefault(require("zustand/shallow"));

var _clsx = _interopRequireDefault(require("clsx"));

var _utils = require("../utils");

var _Mapbox = _interopRequireDefault(require("./Mapbox.styles"));

var _core = require("@material-ui/core");

var _Layers = _interopRequireDefault(require("./Layers"));

var _useResizeObserver2 = _interopRequireDefault(require("use-resize-observer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * A component for rendering an interactive Mapbox map based off of [ReactMapGL](https://github.com/visgl/react-map-gl)
 *
 * To use this component add it to your project
 *
 * ```
 * npm install @hyperobjekt/mapbox
 * ```
 * or
 * ```
 * yarn add @hyperobjekt/mapbox
 * ```
 *
 * Then import it into your project with:
 *
 * ```
 * import Mapbox from "@hyperobjekt/mapbox"
 * ```
 */
var Mapbox = function Mapbox(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      children = _ref.children,
      defaultViewport = _ref.defaultViewport,
      maxBounds = _ref.maxBounds,
      ContainerProps = _ref.ContainerProps,
      sources = _ref.sources,
      layers = _ref.layers,
      onHover = _ref.onHover,
      onClick = _ref.onClick,
      onLoad = _ref.onLoad,
      props = _objectWithoutProperties(_ref, ["classes", "className", "children", "defaultViewport", "maxBounds", "ContainerProps", "sources", "layers", "onHover", "onClick", "onLoad"]);

  // loaded value and setter
  var _useMapStore = (0, _hooks.useMapStore)(function (state) {
    return [state.loaded, state.setLoaded];
  }, _shallow["default"]),
      _useMapStore2 = _slicedToArray(_useMapStore, 2),
      loaded = _useMapStore2[0],
      setLoaded = _useMapStore2[1]; // track the size of the container element
  // const [containerRef, containerRect] = useBoundingClientRect();


  var _useResizeObserver = (0, _useResizeObserver2["default"])(),
      containerRef = _useResizeObserver.ref,
      _useResizeObserver$wi = _useResizeObserver.width,
      width = _useResizeObserver$wi === void 0 ? 1 : _useResizeObserver$wi,
      _useResizeObserver$he = _useResizeObserver.height,
      height = _useResizeObserver$he === void 0 ? 1 : _useResizeObserver$he;

  var _useMapStore3 = (0, _hooks.useMapStore)(function (state) {
    return [state.selectedFeature, state.setSelectedFeature];
  }, _shallow["default"]),
      _useMapStore4 = _slicedToArray(_useMapStore3, 2),
      selectedFeature = _useMapStore4[0],
      setSelectedFeature = _useMapStore4[1]; // hovered feature and setter


  var _useMapStore5 = (0, _hooks.useMapStore)(function (state) {
    return [state.hoveredFeature, state.setHoveredFeature];
  }, _shallow["default"]),
      _useMapStore6 = _slicedToArray(_useMapStore5, 2),
      hoveredFeature = _useMapStore6[0],
      setHoveredFeature = _useMapStore6[1]; // get map viewport and setter from store


  var _useMapViewport = (0, _hooks.useMapViewport)(),
      _useMapViewport2 = _slicedToArray(_useMapViewport, 2),
      viewport = _useMapViewport2[0],
      setViewport = _useMapViewport2[1]; // function to set the reset viewport


  var setDefaultViewport = (0, _hooks.useMapStore)(function (state) {
    return state.setDefaultViewport;
  }); // sets loading state in the store and fires callback

  var handleLoad = function handleLoad(e) {
    if (loaded) return;
    setLoaded(true);
    onLoad && onLoad(e); // trigger load callback
  }; // updates the viewport on changes


  var handleViewportChange = (0, _react.useCallback)(function (vp) {
    // console.log(keepInBounds(vp, maxBounds));
    loaded && setViewport((0, _utils.keepInBounds)(vp, maxBounds));
  }, [setViewport, maxBounds, loaded]); // updates the hovered feature in the store and fires callback

  var handleHover = function handleHover(_ref2) {
    var _srcEvent$target;

    var features = _ref2.features,
        point = _ref2.point,
        srcEvent = _ref2.srcEvent;
    // if we are hovering outside of the map overlay
    if (!(srcEvent !== null && srcEvent !== void 0 && (_srcEvent$target = srcEvent.target) !== null && _srcEvent$target !== void 0 && _srcEvent$target.classList.contains("overlays"))) return setHoveredFeature(null);
    var newHoveredFeature = features && features.length > 0 ? features[0] : null;
    var isNew = (hoveredFeature === null || hoveredFeature === void 0 ? void 0 : hoveredFeature.id) !== (newHoveredFeature === null || newHoveredFeature === void 0 ? void 0 : newHoveredFeature.id);
    isNew && setHoveredFeature(newHoveredFeature);
    isNew && onHover && onHover(newHoveredFeature, {
      features: features,
      point: point,
      srcEvent: srcEvent
    });
  }; // update the selected feature in the store, and fire callback


  var handleClick = function handleClick(_ref3) {
    var _srcEvent$target2;

    var features = _ref3.features,
        srcEvent = _ref3.srcEvent,
        rest = _objectWithoutProperties(_ref3, ["features", "srcEvent"]);

    // if we are clicking outside of the map overlay, return
    if (!(srcEvent !== null && srcEvent !== void 0 && (_srcEvent$target2 = srcEvent.target) !== null && _srcEvent$target2 !== void 0 && _srcEvent$target2.classList.contains("overlays"))) return;
    var clickedFeature = features && features.length > 0 ? features[0] : null;
    var isNew = (selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.id) !== (clickedFeature === null || clickedFeature === void 0 ? void 0 : clickedFeature.id); // activate feature if one was clicked and this isn't a control click

    setSelectedFeature(isNew ? clickedFeature : null);
    clickedFeature && onClick && onClick(features[0], _objectSpread({
      features: features,
      srcEvent: srcEvent
    }, rest));
  }; // set the default / reset viewport when it changes


  (0, _react.useEffect)(function () {
    defaultViewport && setDefaultViewport(_objectSpread({}, defaultViewport));
  }, [defaultViewport, setDefaultViewport]); // set the map dimensions to the container size (fill container)

  (0, _react.useEffect)(function () {
    setViewport({
      width: width,
      height: height
    });
  }, [width, height, setViewport]);
  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    ref: containerRef,
    className: (0, _clsx["default"])("HypMapbox-root", classes.root, className),
    onMouseLeave: function onMouseLeave(e) {
      return handleHover({
        srcEvent: e
      });
    }
  }, ContainerProps), /*#__PURE__*/_react["default"].createElement(_reactMapGl["default"], _extends({
    className: (0, _clsx["default"])("HypMapbox-map", classes.map),
    onViewportChange: handleViewportChange,
    onHover: handleHover,
    onClick: handleClick,
    onLoad: handleLoad,
    interactiveLayerIds: layers && layers.filter(function (l) {
      return l.interactive;
    })
  }, viewport, props), /*#__PURE__*/_react["default"].createElement(_Layers["default"], {
    sources: sources,
    layers: layers
  }), children));
};

Mapbox.defaultProps = {
  mapStyle: "mapbox://styles/hyperobjekt/cke1roqr302yq19jnlpc8dgr9",
  ContainerProps: {},
  dragRotate: false,
  touchRotate: false,
  dragPan: true,
  touchZoom: true
};
Mapbox.propTypes = {
  /** URL to the mapbox style */
  mapStyle: _propTypes["default"].string,

  /** props to pass to the container component  */
  ContainerProps: _propTypes["default"].object,

  /** handler for when an interactive feature layer is hovered */
  onHover: _propTypes["default"].func,

  /** handler for when an interactive feature is clicked */
  onClick: _propTypes["default"].func,

  /** handler for when the map loads */
  onLoad: _propTypes["default"].func,
  children: _propTypes["default"].node
};
Mapbox.__docgenInfo = {
  "description": "A component for rendering an interactive Mapbox map based off of [ReactMapGL](https://github.com/visgl/react-map-gl)\n\nTo use this component add it to your project\n\n```\nnpm install @hyperobjekt/mapbox\n```\nor\n```\nyarn add @hyperobjekt/mapbox\n```\n\nThen import it into your project with:\n\n```\nimport Mapbox from \"@hyperobjekt/mapbox\"\n```",
  "methods": [],
  "displayName": "Mapbox",
  "props": {
    "mapStyle": {
      "defaultValue": {
        "value": "\"mapbox://styles/hyperobjekt/cke1roqr302yq19jnlpc8dgr9\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "URL to the mapbox style"
    },
    "ContainerProps": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "props to pass to the container component"
    },
    "dragRotate": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "touchRotate": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "dragPan": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    },
    "touchZoom": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    },
    "onHover": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "handler for when an interactive feature layer is hovered"
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "handler for when an interactive feature is clicked"
    },
    "onLoad": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "handler for when the map loads"
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    }
  }
};

var _default = (0, _core.withStyles)(_Mapbox["default"])(Mapbox);

exports["default"] = _default;